import React, { useState, useRef } from "react";
import { useApp } from "context";
import { Custom, Item } from "components";
import { Grid, IconButton } from "@mui/material";
import { IQarePlan } from "interfaces";
import { Enums, Helpers } from "utils";
import GetAppIcon from "@mui/icons-material/GetApp";

type Props = {
  sx?: any;
  qarePlan: IQarePlan | null;
  opened: boolean;
  onClose: () => void;
  handleQarePlanAppointmentOpen: () => void;
};

export const QarePlanPatient = (props: Props) => {
  const { t, theme, service } = useApp();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const hiddenAnchor = useRef<HTMLAnchorElement | null>(null);

  const handleDownloadDocument = async (documentName: string) => {
    const appointmentId = props.qarePlan?.appointmentId ?? NaN;

    const [status, response] = await service.qarePlan.downloadDocument(
      appointmentId,
      documentName
    );

    if (status !== Enums.EnumResponse.Success) return;

    Helpers.download(
      response.data,
      documentName,
      hiddenAnchor.current as HTMLAnchorElement
    );
  };

  return (
    <Custom.Modal
      opened={props.opened}
      header={t.title.myqare_plan}
      onClose={props.onClose}
    >
      <a style={{ display: "none" }} ref={hiddenAnchor} />
      <Grid container spacing={theme.margin.sm}>
        <Grid item xs={12}>
          <Custom.Box variant="filled" title={t.title.reason_visit}>
            <div>{props.qarePlan?.reason}</div>
          </Custom.Box>
        </Grid>
        <Grid item xs={12}>
          <Custom.Box variant="filled" multiline title={t.title.qare_plan}>
            <div>{props.qarePlan?.content}</div>
          </Custom.Box>
        </Grid>
        <Grid item xs={12}>
          <Custom.Box>
            <div>{t.title.my_results + ":"}</div>
            {props.qarePlan?.documentNames.length ? (
              <>
                <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                  <GetAppIcon />
                </IconButton>
                <Custom.Popover
                  anchorEl={anchorEl}
                  onClose={() => setAnchorEl(null)}
                >
                  {props.qarePlan.documentNames.map((dn) => (
                    <Custom.Chip
                      label={dn}
                      key={dn}
                      onClick={() => handleDownloadDocument(dn)}
                    />
                  ))}
                </Custom.Popover>
              </>
            ) : (
              <div style={{ color: theme.color.disabled.color }}>
                {t.label.not_available}
              </div>
            )}
          </Custom.Box>
        </Grid>
        <Grid item xs={12}>
          <Custom.Box variant="outlined" title={t.title.recommended}>
            <Grid container spacing={theme.margin.sm}>
              <Grid item xs={12}>
                <Custom.Box variant="filled">
                  <Item.ServiceIcon
                    serviceId={props.qarePlan?.serviceId ?? NaN}
                  />
                  <div>{props.qarePlan?.service.serviceName}</div>
                </Custom.Box>
              </Grid>
              <Grid item xs={12}>
                <Custom.Box variant="filled">
                  <div>{props.qarePlan?.provider.specialty}</div>
                  <div>
                    {Helpers.replaceComma(
                      props.qarePlan?.provider.username ?? ""
                    )}
                  </div>
                </Custom.Box>
              </Grid>
              <Grid item xs={12}>
                <Custom.Button onClick={props.handleQarePlanAppointmentOpen}>
                  {t.action.make_appointment}
                </Custom.Button>
              </Grid>
            </Grid>
          </Custom.Box>
        </Grid>
      </Grid>
    </Custom.Modal>
  );
};
